export const filterKey = {
    ShipmentId: "",
    ShipmentOriginETDTo: "",
    ShipmentOriginETDFrom: "",
    ShipmentDestinationETATo: "",
    ShipmentDestinationETAFrom: "",
    OrderRef: "",
    HouseBillNumber: "",
    MasterBillNumber: "",
    VesselName: "",
    ConsignorName: "",
    ConsigneeName: "",
    OriginUNLOCO: "",
    DestinationUNLOCO: "",
    OriginName: "",
    ContainerNumbers: "",
    Cost: 0,
    DestinationName: "",
  };

  export const filterKeyCo2 = {
    
  OriginUNLOCO: "",
  DestinationUNLOCO: "",
  OriginPortName: "",
  DestinationPortName: "",
  ShipmentDestinationETAFrom:"",
  ShipmentDestinationETATo:"",
  ShipmentOriginETDFrom:"",
  ShipmentOriginETDTo:"",
  CarrierName: "",
  // ShipmentNumber:"",
  ShipperName:"",
  };